document.addEventListener("DOMContentLoaded", function () {
    const tabButtons = document.querySelectorAll(".tab-btn");
    const tabContents = document.querySelectorAll(".tab-content");

    function activateTab(button, updateUrl = true) {
      const targetTab = button.getAttribute("data-tab");
      const tabQuery = button.getAttribute("data-query");

      // Remove active classes
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabContents.forEach((tab) => tab.classList.remove("active"));

      // Add active classes
      button.classList.add("active");
      document.getElementById(targetTab).classList.add("active");

      // Update URL
      if (updateUrl && tabQuery) {
        const url = new URL(window.location);
        url.searchParams.set("tab", tabQuery);
        window.history.replaceState({}, "", url); // 👈 replace on load
      }
    }

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => activateTab(button));
    });

    const urlParams = new URLSearchParams(window.location.search);
    const tabFromUrl = urlParams.get("tab");

    if (tabFromUrl) {
      // Case 1: URL already has tab
      const matchingButton = document.querySelector(
        `.tab-btn[data-query="${tabFromUrl}"]`
      );

      if (matchingButton) {
        activateTab(matchingButton, false);
        return;
      }
    }

    // Case 2: No tab in URL → use default active tab
    const defaultActiveTab = document.querySelector(".tab-btn.active");

    if (defaultActiveTab) {
      activateTab(defaultActiveTab);
    }
});

//   document.addEventListener("DOMContentLoaded", function () {
//     const bundleButtons = document.querySelectorAll(".bundle-atc");

//     bundleButtons.forEach((button) => {
//       button.addEventListener("click", async function () {
//         const productHandles = button.dataset.products
//           .split(",")
//           .filter(Boolean);

//         if (productHandles.length === 0) return;

//         const formItems = [];

//         for (const handle of productHandles) {
//           try {
//             const res = await fetch(`/products/${handle}.js`);
//             const product = await res.json();
//             if (product.variants && product.variants.length > 0) {
//               formItems.push({
//                 id: product.variants[0].id,
//                 quantity: 1,
//               });
//             }
//           } catch (error) {
//             console.error("Product not found:", handle);
//           }
//         }

//         if (formItems.length > 0) {
//           fetch("/cart/add.js", {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//               Accept: "application/json",
//             },
//             body: JSON.stringify({ items: formItems }),
//           })
//             .then((res) => res.json())
//             .then((data) => {
//             //   
//               // Optional: show confirmation or reload cart
//                if (window.openSidecart) {
//             window.openSidecart();
//             if (window.fetchCart) window.fetchCart();
//           }
//             })
//             .catch((err) => {
//               console.error("Error adding bundle:", err);
//             });
//         }
//       });
//     });
//   });
////////////////////////////////////quanity box js//////////////
// document.addEventListener("DOMContentLoaded", () => {
//   document.querySelectorAll('.quantity__input').forEach(input => {
//     const wrapper = input.closest('.number-input');
//     const minusBtn = wrapper.querySelector('.minus');
//     const plusBtn = wrapper.querySelector('.plus');

//     minusBtn.addEventListener('click', () => {
//       input.value = Math.max(0, parseInt(input.value) - 1);
//       input.dispatchEvent(new Event('input', { bubbles: true }));
//     });

//     plusBtn.addEventListener('click', () => {
//       input.value = parseInt(input.value) + 1;
//       input.dispatchEvent(new Event('input', { bubbles: true }));
//     });
//   });
// });
// Bundle-builder-selsection-code will start from here
// document.addEventListener("DOMContentLoaded", function () {
//   document.querySelectorAll('.bundle-builder-atc').forEach(button => {
//     button.addEventListener('click', () => {
//       const container = button.closest('.product-blockss');
//       if (!container) return;

//       const rightBlocks = Array.from(document.querySelectorAll('.Bundle-right-content'));

//       // Get bundleTitle from button's data-title attribute
//       const bundleTitle = button.getAttribute('data-title')?.trim() || '';

//       const bundleItems = [];

//       for (let i = 1; i <= 4; i++) {
//         const block = container.querySelector(`.product-image${i}`);
//         const imgEl = block?.querySelector('img');
//         if (!imgEl || !imgEl.src || imgEl.src.includes('no-image')) continue;

//         block.setAttribute('data-quantity', '1');

//         const productId = block.getAttribute('data-product-id') || '';
//         const variantId = block.getAttribute('data-variant-id') || '';
//         const subscription = block.getAttribute('data-subscription') || 'false';
//         const title = block.getAttribute('data-product-title') || '';

//         bundleItems.push({
//           productId,
//           variantId,
//           subscription,
//           title
//         });
//       }

//       if (bundleItems.length === 0) return;

//       const bundleKey = bundleItems.map(item => item.variantId).sort().join(',');

//       const existingBlock = rightBlocks.find(rb => rb.dataset.bundleKey === bundleKey);

//       if (existingBlock) {
//         const currentQty = parseInt(existingBlock.dataset.quantity, 10) || 0;
//         const newQty = currentQty + 1;
//         existingBlock.dataset.quantity = newQty;
//         existingBlock.querySelector('.selected-bundle-qty').textContent = newQty;
//       } else {
//         const emptyBlock = rightBlocks.find(rb => !rb.dataset.productId);
//         if (!emptyBlock) return;

//         emptyBlock.dataset.productId = bundleItems[0].productId;
//         emptyBlock.dataset.variantId = bundleItems[0].variantId;
//         emptyBlock.dataset.bundleKey = bundleKey;
//         emptyBlock.dataset.quantity = 1;
//         emptyBlock.dataset.hasSubscription = bundleItems.some(item => item.subscription !== 'false') ? 'true' : 'false';

//         // ✅ Inject bundle title into the attribute too
//         emptyBlock.dataset.bundleTitle = bundleTitle;

//         // Update title + product list
//         const productTitles = bundleItems.map(item => `<li>${item.title}</li>`).join('');
//         emptyBlock.querySelector('.selected-bundle-products').innerHTML = `<ul>${productTitles}</ul>`;
//         emptyBlock.querySelector('.selected-bundle-title').textContent = bundleTitle;
//         emptyBlock.querySelector('.selected-bundle-qty').textContent = 1;

//         const removeBtn = emptyBlock.querySelector('.bundle-remove');
//         if (removeBtn) {
//           removeBtn.innerHTML = '<button type="button" class="remove-btn">×</button>';
//         }
//       }
//     });
//   });
// });

 
/////////////////////Bundle  secents logic /////////////////////////////////////
document.addEventListener("DOMContentLoaded", function () {
  const placeholders = Array.from(document.querySelectorAll('#selected-scents .placeholder'));

  document.querySelectorAll('.bundle-atc').forEach(button => {
    button.addEventListener('click', () => {

      const container = button.closest('.product-blockss');
      const isSingleProduct = button.hasAttribute('data-single-product');
    const singleTitle = button.getAttribute('data-single-product')?.trim();

     const isAddon = button.hasAttribute('data-addon-product');
     const higherpriceitem = button.hasAttribute('data-tags');
     const addonTitle = button.getAttribute('data-addon-product');
     const isnodiscountot = button.hasAttribute('data-discount-tag');
     const nodiscountot = button.getAttribute('data-discount-tag');
      
    // slot.dataset.title = addonTitle;
    // slot.dataset.variantId = button.getAttribute('data-variant-id') || '';
    // slot.dataset.price = addonPrice * 100; // store in cents
             //  mark as addon
    // slot.dataset.quantity = '0';

    // const idx = slot.dataset.index;
    // slot.querySelector(`.product-qty${idx}`).textContent = '0';
    // slot.querySelector(`.product-image${idx}`).innerHTML =
    //     `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Vector_85.png?v=1753096645" alt="">`;
    // slot.querySelector('.remove-btn')?.classList.remove('hidden');

    
      
      if (!container) return;

if (isSingleProduct) {
  const productImageEl = container.querySelector('.product-image1 img');
  const variantId = container.querySelector('.product-image1')?.getAttribute('data-variant-id') || '';
  const productId = container.querySelector('.product-image1')?.getAttribute('data-product-id') || '';
  const subscription = container.querySelector('.product-image1')?.getAttribute('data-subscription') || 'false';
  const productTitle = container.querySelector('.product-image1')?.getAttribute('data-product-title') || '';
  const productPrice = container.querySelector('.product-image1')?.getAttribute('data-price') || '';
// alert(productPrice)
  if (!productImageEl || productImageEl.src.includes('no-image')) {
    console.log(" No valid image found for single product.");
    return;
  }

  // 1. Update placeholder section
  let slot = placeholders.find(ph => ph.dataset.variantId === variantId);
  if (slot) {
    const idx = slot.dataset.index;
    const qtyEl = slot.querySelector(`.product-qty${idx}`);
    const newQty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
    qtyEl.textContent = newQty;
    slot.setAttribute('data-quantity', newQty);
      slot.dataset.isAddon = isAddon ? 'true' : 'false';
      slot.dataset.higherpriceitem = higherpriceitem ? 'true' : 'false';
      slot.dataset.isnodiscountot = isnodiscountot ? 'true' : 'false';
        slot.dataset.isMist = container
        .querySelector('.product-image1')
        ?.getAttribute('data-is-mist') === 'true'
          ? 'true'
          : 'false';

        
      
  } else {
    const emptySlot = placeholders.find(ph => !ph.dataset.image);
    if (emptySlot) {
      const idx = emptySlot.dataset.index;
      emptySlot.dataset.image = productImageEl.src;
      emptySlot.dataset.productId = productId;
      emptySlot.dataset.variantId = variantId;
      emptySlot.dataset.quantity = '1';
      emptySlot.dataset.hasSubscription = subscription;
      emptySlot.dataset.title = productTitle;
       emptySlot.dataset.price = productPrice;
       //  assign to placeholder
       emptySlot.dataset.isAddon = isAddon ? 'true' : 'false';
       emptySlot.dataset.higherpriceitem = higherpriceitem ? 'true' : 'false';
       emptySlot.dataset.isnodiscountot = isnodiscountot ? 'true' : 'false';
            emptySlot.dataset.isMist =
        container
          .querySelector('.product-image1')
          ?.getAttribute('data-is-mist') === 'true'
          ? 'true'
          : 'false';

       
      emptySlot.querySelector(`.product-image${idx}`).innerHTML = `<img src="${productImageEl.src}" alt="">`;
      emptySlot.querySelector(`.product-qty${idx}`).textContent = '1';
      emptySlot.querySelector('.remove-btn')?.classList.remove('hidden');
      updatePlaceholderActiveState();
      updateTabDots();
    }
  }

  // 2. Update .Bundle-right-content (title only, no product list)
  let singleBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
    .find(el => el.dataset.variantIds === variantId);

  if (singleBlock) {
    const qtyEl = singleBlock.querySelector('.selected-bundle-qty');
    const updatedQty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
    qtyEl.textContent = updatedQty;
    singleBlock.setAttribute('data-quantity', updatedQty);
  } else {
    const emptyBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
      .find(el => !el.dataset.image);

 if (emptyBlock) {

  //  Update only attributes — DO NOT touch the structure
  emptyBlock.setAttribute('data-bundle-title', ''); // blank for single
  emptyBlock.setAttribute('data-quantity', '1');
  emptyBlock.setAttribute('data-image', productImageEl.src);
  emptyBlock.setAttribute('data-product-id', productId);
  emptyBlock.setAttribute('data-variant-ids', variantId);
  emptyBlock.setAttribute('data-has-subscription', subscription);

  //  Now safely update the inner elements (assuming HTML is already there)
  const titleEl = emptyBlock.querySelector('.selected-bundle-title');
  const productsEl = emptyBlock.querySelector('.selected-bundle-products');
  const qtyEl = emptyBlock.querySelector('.selected-bundle-qty');

  if (titleEl) titleEl.textContent = singleTitle;     //  This line is key!
  if (productsEl) productsEl.innerHTML = '';           // Hides bundle list
  if (qtyEl) qtyEl.textContent = '1';
  
}
      toggleEmptyBundleMessage();
      updateOneTimePriceDisplay();
      updateSubscriptionPriceDisplay();
      updateAtcPriceBySelection();
      updateTabDots();
  }

  // 3. Setup qty box
  const qtyInput = container.querySelector('.quantity__input');
  const minusBtn = container.querySelector('.qty-btn.minus');
  const plusBtn = container.querySelector('.qty-btn.plus');

  qtyInput.value = 1;
  button.style.display = 'none';
  container.querySelector('.bundle-qtty').style.display = 'flex';
   container.classList.add('active');

  plusBtn.onclick = () => {
  
    let newVal = parseInt(qtyInput.value, 10) + 1;
    qtyInput.value = newVal;

    let block = Array.from(document.querySelectorAll('.Bundle-right-content'))
      .find(el => el.dataset.variantIds === variantId);
    if (block) {
      block.querySelector('.selected-bundle-qty').textContent = newVal;
      block.setAttribute('data-quantity', newVal);
    }

    const slot = placeholders.find(ph => ph.dataset.variantId === variantId);
    if (slot) {
      // const idx = slot.dataset.index;
      // slot.querySelector(`.product-qty${idx}`).textContent = newVal;
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const updated = (parseInt(qtyEl.textContent, 10) || 0) + 1;
            qtyEl.textContent = updated;
            slot.setAttribute('data-quantity', newVal);
            // slot.setAttribute('data-quantity', updated);
            // block.setAttribute('data-quantity', updated);
    }
    
    toggleEmptyBundleMessage();
    updateOneTimePriceDisplay();
    updateSubscriptionPriceDisplay();
    updatePlaceholderActiveState();
    updateAtcPriceBySelection();
    updateTabDots();

  };

  minusBtn.onclick = () => {
    let newVal = Math.max(0, parseInt(qtyInput.value, 10) - 1);
    qtyInput.value = newVal;

    let block = Array.from(document.querySelectorAll('.Bundle-right-content'))
      .find(el => el.dataset.variantIds === variantId);
    if (block) {
      block.querySelector('.selected-bundle-qty').textContent = newVal;
      block.setAttribute('data-quantity', newVal);

      if (newVal === 0) {
         block.setAttribute('data-quantity', '0');
        block.removeAttribute('data-image');
        block.removeAttribute('data-product-id');
        block.removeAttribute('data-variant-ids');
        block.removeAttribute('data-has-subscription');
        // block.removeAttribute('data-quantity');
        block.querySelector('.selected-bundle-title').textContent = '';
        block.querySelector('.selected-bundle-qty').textContent = '';
      }
    }

    const slot = placeholders.find(ph => ph.dataset.variantId === variantId);
    if (slot) {
      const idx = slot.dataset.index;
      const updatedVal = Math.max(0, parseInt(slot.querySelector(`.product-qty${idx}`).textContent, 10) - 1);
      slot.querySelector(`.product-qty${idx}`).textContent = updatedVal;
      slot.setAttribute('data-quantity', updatedVal);

      if (updatedVal === 0) {
        slot.querySelector(`.product-image${idx}`).innerHTML =
          `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Vector_85.png?v=1753096645" alt="placeholder">`;
        delete slot.dataset.image;
        delete slot.dataset.productId;
        delete slot.dataset.variantId;
        delete slot.dataset.quantity;
        delete slot.dataset.hasSubscription;
      }
    }

    if (newVal === 0) {
      button.style.display = '';
       container.querySelector('.bundle-qtty').style.display = 'none';
       container.classList.remove('active');
    }
        toggleEmptyBundleMessage();
    updateOneTimePriceDisplay();
    updateSubscriptionPriceDisplay();
    updatePlaceholderActiveState();
    updateAtcPriceBySelection();
    updateTabDots();
  };

  return; // ✅ prevent bundle logic from executing
}

      const productEntries = [];
      // const bundleTitle = container.querySelector('.bundle-title')?.textContent.trim();

      for (let i = 1; i <= 4; i++) {
      const block = container.querySelector(`.product-image${i}`);
  const imgEl = block?.querySelector('img');
  if (!imgEl || !imgEl.src || imgEl.src.includes('no-image')) continue;

  block.setAttribute('data-quantity', '1');

  productEntries.push({
    src: imgEl.src,
    productId: block.getAttribute('data-product-id') || '',
    variantId: block.getAttribute('data-variant-id')   || '',
    subscription: block.getAttribute('data-subscription') || 'false',
    block: block
  });

      }

      productEntries.forEach(({ src, productId, variantId, subscription, block }) => {
        let slot = placeholders.find(ph => ph.dataset.image === src);
        if (slot) {
          const idx = slot.dataset.index;
          const qtyEl = slot.querySelector(`.product-qty${idx}`);
          const updated = (parseInt(qtyEl.textContent, 10) || 0) + 1;
          qtyEl.textContent = updated;
          slot.setAttribute('data-quantity', updated);
         
        } else {
          const slot2 = placeholders.find(ph => !ph.dataset.image);
          if (!slot2) return;

          const idx = slot2.dataset.index;
          slot2.dataset.image = src;
          slot2.dataset.productId = productId;
          slot2.dataset.variantId = variantId;
          slot2.dataset.quantity = '1';
          slot2.dataset.hasSubscription = subscription;
          //  MARK BUNDLE ITEM AS MIST OR NOT
        slot2.dataset.isMist =
          block.getAttribute('data-is-mist') === 'true' ? 'true' : 'false';

          // slot2.dataset.bundleTitle = bundleTitle || '';
const price = block.getAttribute('data-price'); // assuming the left block has this
slot2.dataset.price = price || '0';
// alert(price);

          const productBlock = container.querySelector(`[data-product-id="${productId}"][data-variant-id="${variantId}"]`);
          slot2.dataset.title = productBlock?.getAttribute('data-product-title') || '';

          slot2.querySelector(`.product-image${idx}`).innerHTML = `<img src="${src}" alt="">`;
          slot2.querySelector(`.product-qty${idx}`).textContent = '1';

          const rm = slot2.querySelector('.remove-btn');
          if (rm) rm.classList.remove('hidden');
        }
      });

 updatePlaceholderActiveState();
      // ✅ Update .Bundle-right-content block (Right-side summary)
// const bundleTitle = button.getAttribute('data-title')?.trim() || "Untitled Bundle";
const bundleTitle = button.getAttribute('data-title-new')?.trim() || "Untitled Bundle";

const productNames = productEntries.map(p => p.block?.getAttribute("data-product-title")).filter(Boolean);

// Try to find a block that already has this bundle title
let bundleBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
  .find(el => el.getAttribute('data-bundle-title') === bundleTitle);

if (bundleBlock) {
  // 🔄 Update existing bundle block: increment quantity
  const qtyEl = bundleBlock.querySelector('.selected-bundle-qty');
  const updatedQty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
  qtyEl.textContent = updatedQty;
  bundleBlock.setAttribute('data-quantity', updatedQty);
} else {
  // ➕ Fill first empty block with bundle info
const emptyBlock = Array.from(document.querySelectorAll('.Bundle-right-content')).find(el => {
  const bundleTitle = el.getAttribute('data-bundle-title');
  const productId = el.getAttribute('data-product-id');
  const image = el.getAttribute('data-image');
  return !bundleTitle && !productId && !image;
});

 if (emptyBlock) {
  const firstEntry = productEntries[0];

  emptyBlock.setAttribute('data-bundle-title', bundleTitle);
  emptyBlock.setAttribute('data-quantity', '1');
  emptyBlock.setAttribute('data-image', firstEntry?.src || '');
  emptyBlock.setAttribute('data-product-id', firstEntry?.productId || '');
  // emptyBlock.setAttribute('data-variant-id', firstEntry?.variantId || '');
  const allVariantIds = productEntries.map(p => p.variantId).filter(Boolean);
emptyBlock.setAttribute('data-variant-ids', allVariantIds.join(','));

  emptyBlock.setAttribute('data-has-subscription', firstEntry?.subscription || 'false');

  const titleEl = emptyBlock.querySelector('.selected-bundle-title');
  const productsEl = emptyBlock.querySelector('.selected-bundle-products');
  const qtyEl = emptyBlock.querySelector('.selected-bundle-qty');

  // if (titleEl) titleEl.textContent = bundleTitle.toUpperCase();
  if (titleEl) titleEl.textContent = bundleTitle.split('_')[0].toUpperCase();
  if (productsEl) {
    productsEl.innerHTML = productNames.map(name => `<div>${name}</div>`).join('');
  }
  if (qtyEl) qtyEl.textContent = '1';
}
    toggleEmptyBundleMessage();
    updateOneTimePriceDisplay();
    updateSubscriptionPriceDisplay();
    updateAtcPriceBySelection();
    updateTabDots();
}

      const qtyInput = container.querySelector('.quantity__input');
      const minusBtn = container.querySelector('.qty-btn.minus');
      const plusBtn = container.querySelector('.qty-btn.plus');

      qtyInput.value = 1;
      button.style.display = 'none';
      container.querySelector('.bundle-qtty').style.display = 'flex';
      container.classList.add('active');

      plusBtn.onclick = () => {
        let newVal = parseInt(qtyInput.value, 10) + 1;
        qtyInput.value = newVal;
// 🔄 Update Bundle-right-content qty block
// const bundleTitle = button.getAttribute('data-title')?.trim() || "Untitled Bundle";
const bundleTitle = button.getAttribute('data-title-new')?.trim() || "Untitled Bundle";

const bundleBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
  .find(el => el.getAttribute('data-bundle-title') === bundleTitle);
if (bundleBlock) {
  const qtyEl = bundleBlock.querySelector('.selected-bundle-qty');
  const newBundleQty = (parseInt(qtyEl.textContent, 10) || 0) + 1;
  qtyEl.textContent = newBundleQty;
  bundleBlock.setAttribute('data-quantity', newBundleQty);
}

        productEntries.forEach(({ src, block }) => {
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const updated = (parseInt(qtyEl.textContent, 10) || 0) + 1;
            qtyEl.textContent = updated;
            slot.setAttribute('data-quantity', updated);
            block.setAttribute('data-quantity', updated);
          }
        });
         toggleEmptyBundleMessage();
         updateOneTimePriceDisplay();
         updateSubscriptionPriceDisplay();
         updatePlaceholderActiveState();
         updateAtcPriceBySelection();
         updateTabDots();

      };

      minusBtn.onclick = () => {
        let newVal = Math.max(0, parseInt(qtyInput.value, 10) - 1);
        qtyInput.value = newVal;
// 🔄 Decrease Bundle-right-content qty
// const bundleTitle = button.getAttribute('data-title')?.trim() || "Untitled Bundle";
const bundleTitle = button.getAttribute('data-title-new')?.trim() || "Untitled Bundle";

const bundleBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
  .find(el => el.getAttribute('data-bundle-title') === bundleTitle);
if (bundleBlock) {
  const qtyEl = bundleBlock.querySelector('.selected-bundle-qty');
  const oldQty = parseInt(qtyEl.textContent, 10) || 0;
  const newQty = Math.max(0, oldQty - 1);
  qtyEl.textContent = newQty;
  bundleBlock.setAttribute('data-quantity', newQty);

  //  Optionally clear the block if qty hits 0
  if (newQty === 0) {
     bundleBlock.setAttribute('data-quantity', '0');
    bundleBlock.setAttribute('data-bundle-title', '');
    // bundleBlock.setAttribute('data-quantity', '');
    bundleBlock.querySelector('.selected-bundle-title').textContent = '';
    bundleBlock.querySelector('.selected-bundle-products').innerHTML = '';
    bundleBlock.querySelector('.selected-bundle-qty').textContent = '';
  }
   updatePlaceholderActiveState();
}

        productEntries.forEach(({ src, block }) => {
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const existingVal = parseInt(qtyEl.textContent, 10) || 0;
            const updatedVal = Math.max(0, existingVal - 1);
            qtyEl.textContent = updatedVal;
            slot.setAttribute('data-quantity', updatedVal);
            block.setAttribute('data-quantity', updatedVal);

            if (updatedVal === 0) {
              delete slot.dataset.image;
              delete slot.dataset.productId;
              delete slot.dataset.variantId;
              delete slot.dataset.quantity;
              delete slot.dataset.hasSubscription;
              delete slot.dataset.bundleTitle;

              slot.querySelector(`.product-image${idx}`).innerHTML =
                `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Vector_85.png?v=1753096645" alt="placeholder">`;
              qtyEl.textContent = '0';

              block.removeAttribute('data-quantity');   
            }
          }
        });

    if (newVal === 0) {
        button.style.display = '';
        container.querySelector('.bundle-qtty').style.display = 'none';
        container.classList.remove('active');
    }
         toggleEmptyBundleMessage();
      updateOneTimePriceDisplay();
      updateSubscriptionPriceDisplay();
      updatePlaceholderActiveState();
      updateAtcPriceBySelection();
      updateTabDots();
      };
    });
  });
  });

      function updateTabDots() {
        document.querySelectorAll('.tabs-wrapper').forEach(wrapper => {
          const buttons = wrapper.querySelectorAll('.tab-btn');
          const contents = wrapper.querySelectorAll('.tab-content');

          buttons.forEach((btn, index) => {
            const content = contents[index];

            if (content) {
              // Delay to ensure .active class is applied
              setTimeout(() => {
                let hasActiveProduct = false;

                const activeBlock = content.querySelector('.product-blockss.active');
                if (activeBlock) {
                  hasActiveProduct = true;
                }

                // Select the dot inside the same wrapper
                const dot = btn.parentElement.querySelector('.tab-dot');
                if (dot) {
                  if (hasActiveProduct) {
                    dot.classList.remove('hidden');
                    dot.classList.add('visible');
                  } else {
                    dot.classList.add('hidden');
                    dot.classList.remove('visible');
                  }
                }

              }, 50); // 50ms delay
            }
          });
        });
      }

function updatePlaceholderActiveState() {
  const placeholders = document.querySelectorAll('#selected-scents .placeholder');

  placeholders.forEach(ph => {
    const hasProduct = ph.querySelector('.product-title') || ph.dataset.productId;

    if (hasProduct) {
      ph.classList.add('active');
    } else {
      ph.classList.remove('active');
    }
  });
}

// Subscription code start from here

document.addEventListener("DOMContentLoaded", function() {
  const sourceEl = document.querySelector('.product-image1');
  const priceCents = sourceEl?.getAttribute('data-price');

  if (priceCents) {
    const price = (parseInt(priceCents, 10) / 100).toFixed(2); // ✅ convert to dollars
    const targetElements = document.querySelectorAll('.one-time-discount-price');

    targetElements.forEach(el => {
      el.innerHTML += ` $${price}`;
    });
  }
});

//  Updated Add to Cart code (based on .Bundle-right-content blocks instead of .placeholder)
document.addEventListener("DOMContentLoaded", function () {
  const atcBtns = document.querySelectorAll('.bundle-product-atc, .bundle-sticky-atc');

  if (!atcBtns.length) return;

  atcBtns.forEach(atcBtn => {
    atcBtn.addEventListener("click", async function () {
      atcBtn.classList.add("disable");
      atcBtn.classList.add('loading');   // --- Show loader on button ---

      const hasItems = Array.from(document.querySelectorAll('.Bundle-right-content'))
  .some(b => parseInt(b.dataset.quantity, 10) > 0);

    if (!hasItems) {
      alert("Please select at least one scent or bundle.");
      atcBtn.classList.remove("disable", "loading");
      atcBtn.disabled = false;
      return; 
    }
    // ------------------------------
// STEP 1: Detect if user selected ONE-TIME
// ------------------------------
    const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
    // --- NEW LOGIC START ---
    // Check if any selected item is a *subscription-eligible* product
    const hasSubscriptionEligibleItem = Array.from(document.querySelectorAll('.Bundle-right-content'))
        .some(block => {
            const quantity = parseInt(block.dataset.quantity, 10) || 0;
            const hasSubscription = block.dataset.hasSubscription;
            // Only check blocks with quantity > 0
            if (quantity <= 0) return false;

            // Return true if the block is selected AND has subscription capability
            return hasSubscription && hasSubscription !== "false" && hasSubscription !== "0";
        });
    // --- NEW LOGIC END ---
 
  if (purchaseOption === "onetime" && hasSubscriptionEligibleItem) {
    if (window.ctrSubscriptionPopup && window.ctrSubscriptionPopup.intercept()) {
      atcBtn.classList.remove("disable", "loading");
      atcBtn.disabled = false;
      return;
    }
  }

      const blocks = Array.from(document.querySelectorAll('.Bundle-right-content'));
      const items = [];
      let hasValidProduct = false;
      const processedBundles = new Set();

      blocks.forEach((block, i) => {
        const uniqueId = `m${Math.random().toString(36).substr(2, 9)}`;
        const fullBundleTitle = block.dataset.bundleTitle?.trim();
        const bundleTitle = fullBundleTitle?.split('_')[0];
        const quantity = parseInt(block.dataset.quantity, 10) || 1;
        const hasSubscription = block.dataset.hasSubscription;
        const variantIds = (block.dataset.variantIds || '').split(',').map(id => id.trim()).filter(Boolean);

        if (variantIds.length === 0 || quantity <= 0) return;
        hasValidProduct = true;

        //  BUNDLE product
        if (fullBundleTitle) {
          if (processedBundles.has(fullBundleTitle)) return;
          processedBundles.add(fullBundleTitle);

          const titles = Array.from(block.querySelectorAll('.selected-bundle-products div')).map(d => d.textContent.trim());

          variantIds.forEach((variantId, index) => {
            const item = {
              id: parseInt(variantIds[index], 10),
              quantity: quantity,
              properties: {
                "_bundle_items": true,
                "_unique_id": uniqueId,
                "Bundle Name": bundleTitle,
                "Included Products": titles.join(', ')
              }
            };

            const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
            if (purchaseOption === "subscription" && hasSubscription !== "false" && hasSubscription !== "0") {
              const planSelect = document.querySelector(`.subscription-dropdown[data-product-id="${variantId}"]`);
              const selectedOption = planSelect?.selectedOptions[0];
              const sellingPlanId = selectedOption?.value;

              if (sellingPlanId) {
                item.selling_plan = parseInt(sellingPlanId, 10);
              }
            } else {
              item.properties["Purchase Type"] = "One Time";
            }

            items.push(item);
          });

        } 
        //  SINGLE product
        else {
          const item = {
            id: parseInt(variantIds[0], 10),
            quantity: quantity,
            properties: {}
          };

          const purchaseOption = document.querySelector('input[name="purchase-option"]:checked')?.value;
          if (purchaseOption === "subscription" && hasSubscription !== "false" && hasSubscription !== "0") {
            const planSelect = document.querySelector(`.subscription-dropdown[data-product-id="${variantIds[0]}"]`);
            const selectedOption = planSelect?.selectedOptions[0];
            const sellingPlanId = selectedOption?.value;

            if (sellingPlanId) {
              item.selling_plan = parseInt(sellingPlanId, 10);
            }
          } else {
            item.properties["Purchase Type"] = "One Time";
          }

          if (Object.keys(item.properties).length === 1 && item.properties["Purchase Type"]) {
            delete item.properties;
          }

          items.push(item);
        }
      });

      if (!hasValidProduct) {
        alert("Please select at least one scent or bundle.");
        atcBtn.classList.remove("disable", "loading");
        atcBtn.disabled = false;
        return;
      }

      console.log(" Final items to send to cart:", items);

      if (window.ctrSubscriptionPopup && window.ctrSubscriptionPopup.applyToItems) {
        window.ctrSubscriptionPopup.applyToItems(items);
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const errData = await response.json();
          throw new Error(errData.description || "Unknown cart error");
        }

        const data = await response.json();

        if (window.openSidecart) {
          window.openSidecart();
          if (window.fetchCart) window.fetchCart();
        }
      } catch (err) {
        console.error(" Cart add failed:", err);
        alert(err);
      } finally {
        atcBtn.disabled = false;
        atcBtn.classList.remove("disable", "loading");
      }
    });
  });
});

function toggleEmptyBundleMessage() {
  const allBlocks = document.querySelectorAll('.Bundle-right-content');
  const selectedBundles = document.querySelector('#selected-bundles');
  const hasFilledBlock = Array.from(allBlocks).some(block => {
    const title = block.getAttribute('data-bundle-title')?.trim();
    const variantId = block.getAttribute('data-variant-ids')?.trim();
    const quantity = parseInt(block.getAttribute('data-quantity'), 10);
    return (title || variantId) && quantity > 0;
  });
selectedBundles.style.display = hasFilledBlock ? 'block' : 'none';
  const emptyBundleEl = document.querySelector('.empty_bundle');
  if (emptyBundleEl) {
    emptyBundleEl.style.display = hasFilledBlock ? 'none' : 'block';
  }
}

/////////////////////////////////
/**
 * Accordion functionality for product rewards
 */
const accordionQuestions = document.querySelectorAll('.bundle-right-section .accordion-question');
accordionQuestions.forEach(question => {
  question.addEventListener('click', () => {
    const answer = question.nextElementSibling;
    const isActive = question.classList.contains('active');
    accordionQuestions.forEach(q => {
      if (q !== question) {
        q.classList.remove('active');
        q.nextElementSibling.classList.remove('active');
      }
    });
    question.classList.toggle('active');
    answer.classList.toggle('active');
  });
});
/**
 * Product Detail Drawer functionality
 */
document.addEventListener('DOMContentLoaded', function () {
  const accordionQuestions = document.querySelectorAll('.accordion-question');
  accordionQuestions.forEach(question => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const isActive = question.classList.contains('active');
      accordionQuestions.forEach(q => {
        if (q !== question) {
          q.classList.remove('active');
          q.nextElementSibling.classList.remove('active');
        }
      });
      question.classList.toggle('active');
      answer.classList.toggle('active');
    });
  });
});
/**
 * Product Your Selection Drawer functionality
 */
// document.addEventListener('DOMContentLoaded', function () {
//   const drawer = document.querySelector('.bundle-right-section');
//   const overlay = document.querySelector('.product-your-selection-drawer-overlay');
//   function toggleSelectionDrawer() {
//     drawer.classList.toggle('open');
//     overlay.classList.toggle('visible');
//     document.body.classList.toggle('body-drawer-open');
//   }
//   document.querySelector('.bundle-mobile-sticky-open').addEventListener('click', toggleSelectionDrawer);
//   document.querySelector('.bundle-mobile-sticky-close').addEventListener('click', toggleSelectionDrawer);
// });

// Onetime price update function code start here
let lastOneTimeDiscount = 0;

function updateOneTimePriceDisplay() {
    const placeholders = Array.from(document.querySelectorAll('#selected-scents .placeholder'));
    let totalQty = 0;
    let basePrice = 0;
    let hasHigherPriceItem = false;

    // NEW: Separate qty counters
    let discountEligibleQty = 0;
    let noDiscountQty = 0;

    // Count non-addon items
    placeholders.forEach(ph => {
        const isAddon = ph.dataset.isAddon === 'true';
        if (isAddon) return;

        const index = ph.dataset.index;
        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
        const price = parseFloat(ph.dataset.price || '0') / 100;

        const isHigherPriceItem = ph.dataset.higherpriceitem === 'true';
        if (isHigherPriceItem) hasHigherPriceItem = true;

        // NEW LOGIC — only change you needed
        if (ph.dataset.isnodiscountot === "true") {
            noDiscountQty += qty;      // these items do NOT get discount
        } else {
            discountEligibleQty += qty; // these items DO get discount
        }

        totalQty += qty;       
        basePrice += qty * price;
    });

    // Calculate discount ONLY for discount-eligible qty
  let totalDiscount = 0;
  let discountedPrice = basePrice;

  if (discountEligibleQty === 2) {
      totalDiscount = 8;
      discountedPrice = basePrice - totalDiscount;
  } 
  else if (discountEligibleQty === 3) {
      totalDiscount = 19.20;
      discountedPrice = basePrice - totalDiscount;
  } 
  else if (discountEligibleQty >= 4) {
      const discountedUnitPrice = 31.99;

      // Apply per-item pricing
      const eligibleTotal = discountEligibleQty * discountedUnitPrice;

      // Handle mixed carts safely
      const avgPrice = totalQty > 0 ? basePrice / totalQty : 0;
      const nonDiscountTotal = (totalQty - discountEligibleQty) * avgPrice;

      discountedPrice = eligibleTotal + nonDiscountTotal;

      totalDiscount = basePrice - discountedPrice;
  }

    // Save for external access
    lastOneTimeDiscount = totalDiscount;

    // Add-ons total
    let addonTotal = 0;
    placeholders.forEach(ph => {
        if (ph.dataset.isAddon !== 'true') return;

        const index = ph.dataset.index;
        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
        const price = parseFloat(ph.dataset.price || '0') / 100;

        addonTotal += qty * price;
    });

    const finalATCPrice = discountedPrice + addonTotal;

    // Your remaining code is unchanged...
    const atcButtons = document.querySelectorAll('.bundle-product-atc');
    atcButtons.forEach(btn => {
        const addToCartText = btn.querySelector('.addtocarttotal-text');
        const atcPriceDiv = btn.querySelector('.add-total-price');

        if (atcPriceDiv) atcPriceDiv.textContent = `$${finalATCPrice.toFixed(2)}`;
        if (addToCartText) addToCartText.style.display = finalATCPrice > 0 ? 'inline' : 'none';
    });

    const stickyBtn = document.querySelector('.bundle-sticky-atc');
    const stickytabheadermob = document.querySelector('.sub-inner-container .tab-header');
    const tabContents = document.querySelector('.subscription-container .tab-contents');
    let atcbutton = document.querySelector('.bundle-product-atc');

    if (stickyBtn) {
        if (totalQty === 0) {
            stickyBtn.textContent = 'Select Scents';
            if (window.matchMedia("(max-width: 767px)").matches) {
                // stickytabheadermob.style.display = "none";
                tabContents.style.display = "none";
                atcbutton.style.backgroundColor = "#084848";
                atcbutton.style.color = "#b6e5e5";
            }
        } else {
            stickyBtn.textContent = `Add to Cart - $${finalATCPrice.toFixed(2)}`;
            if (window.matchMedia("(max-width: 767px)").matches) {
                stickytabheadermob.style.display = "block";
                atcbutton.style.backgroundColor = "#262525";
                atcbutton.style.color = "#fff";
            }
        }
    }

    const oneTimeDisplay = document.querySelector('.one-time-discount-price');
    const oneTimeOriginalDisplay = document.querySelector('.one-time-original-price');

    if (oneTimeDisplay) {
        oneTimeDisplay.textContent = totalQty > 0 ? `$${discountedPrice.toFixed(2)}` : `$34.99`;
    }

    if (oneTimeOriginalDisplay) {
        if (totalQty > 1) {
            oneTimeOriginalDisplay.textContent = `$${basePrice.toFixed(2)}`;
            oneTimeOriginalDisplay.style.display = 'inline';
        } else {
            oneTimeOriginalDisplay.style.display = 'none';
        }
    }

      if (totalQty > 0) {
      if (oneTimeDisplay) {
          oneTimeDisplay.style.display = 'inline';
          oneTimeDisplay.textContent = `$${discountedPrice.toFixed(2)}`;
      }

      if (oneTimeOriginalDisplay && totalQty > 1) {
          oneTimeOriginalDisplay.style.display = 'inline';
          oneTimeOriginalDisplay.textContent = `$${basePrice.toFixed(2)}`;
      }
  } else {
      if (oneTimeDisplay) oneTimeDisplay.style.display = 'none';
      if (oneTimeOriginalDisplay) oneTimeOriginalDisplay.style.display = 'none';
  }

    updateSubscriptionByQuantity(totalQty);
    updateTotalQty();
    updateBundleBorders();
    updateBundleProgress();
    window.toggleStickyBySelection?.(true);

}

// subscription price code start from here
// subscription price code start from here
function updateSubscriptionPriceDisplay() {
    const placeholders = Array.from(document.querySelectorAll('#selected-scents .placeholder'));

    let totalQty = 0;                // ALL quantities
    let discountEligibleQty = 0;     // qty that CAN get discount
    let basePrice = 0;
    let hasHigherPriceItem = false;

    let discountEligiblePrice = 0;   // price used for discount
    let noDiscountPrice = 0;         // price that should NOT get discount

    // ---- MAIN LOOP ----
    placeholders.forEach(ph => {
        const isAddon = ph.dataset.isAddon === 'true';
        if (isAddon) return;

        const isNoDiscountOT = ph.dataset.isnodiscountot === "true";
        const index = ph.dataset.index;

        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;

        const price = parseFloat(ph.dataset.price || '0') / 100;

        const isHigherPriceItem = ph.dataset.higherpriceitem === 'true';
        if (isHigherPriceItem) hasHigherPriceItem = true;

        // TOTAL qty always includes everything
        totalQty += qty;

        // BASE PRICE is always all products
        basePrice += qty * price;

        // 🌟 NEW LOGIC:
        // If item is flagged "no discount", DO NOT include in discount qty or discount price
        if (isNoDiscountOT) {
            noDiscountPrice += qty * price;
        } else {
            discountEligibleQty += qty;
            discountEligiblePrice += qty * price;
        }
    });

    // ---- DISCOUNT PERCENT BASED ONLY ON discountEligibleQty ----
    let discountPercent = 0;

    if (discountEligibleQty > 0) {
        if (discountEligibleQty === 1) discountPercent = 13.97;
        else if (discountEligibleQty === 2) discountPercent = 24.98;
        else if (discountEligibleQty === 3) discountPercent = 27.98;
        else if (discountEligibleQty >= 4) discountPercent = 30;
        // else if (discountEligibleQty === 5) discountPercent = 22.30;
        // else if (discountEligibleQty >= 6) discountPercent = 23.34;
    }

    // Apply discount ONLY to discount-eligible items
    const discountAmount = discountEligiblePrice * (discountPercent / 100);

    // Combined discounted part + non-discounted part
    const discountedPrice = (discountEligiblePrice - discountAmount) + noDiscountPrice;

    // ---- ADDONS ----
    let addonTotal = 0;
    placeholders.forEach(ph => {
        if (ph.dataset.isAddon !== 'true') return;

        const index = ph.dataset.index;
        const qtyEl = ph.querySelector(`.product-qty${index}`);
        const qty = qtyEl ? parseInt(qtyEl.textContent || '0', 10) : 0;
        const price = parseFloat(ph.dataset.price || '0') / 100;

        addonTotal += qty * price;
    });

    const finalATCPrice = discountedPrice + addonTotal;

    // ---- UPDATE UI ----
    const atcButtons = document.querySelectorAll('.bundle-product-atc');
    atcButtons.forEach(btn => {
        const addToCartText = btn.querySelector('.addtocarttotal-text');
        const atcPriceDiv = btn.querySelector('.add-total-price');

        if (atcPriceDiv) atcPriceDiv.textContent = `$${finalATCPrice.toFixed(2)}`;
        if (addToCartText) addToCartText.style.display = finalATCPrice > 0 ? 'inline' : 'none';
    });

    // Sticky button
    const stickyBtn = document.querySelector('.bundle-sticky-atc');
    const stickytabheadermob = document.querySelector('.sub-inner-container .tab-header');

    if (stickyBtn) {
        if (totalQty === 0) {
            stickyBtn.textContent = 'Select Scents';
            if (window.matchMedia("(max-width: 767px)").matches) {
                // stickytabheadermob.style.display = "none";
            }
        } else {
            stickyBtn.textContent = `Add to Cart - $${finalATCPrice.toFixed(2)}`;
            if (window.matchMedia("(max-width: 767px)").matches) {
                stickytabheadermob.style.display = "block";
            }
        }
    }

    const subDisplay = document.querySelector('.subscription-discount-price');
    const subOriginalDisplay = document.querySelector('.subscription-original-price');
    const subpopupdiscount = document.querySelector('.sub-discount');

    if (subDisplay) {
        subDisplay.textContent = totalQty > 0 ? `$${discountedPrice.toFixed(2)}` : `$29.99`;
    }
 
    if (subOriginalDisplay) {
        subOriginalDisplay.textContent = `$${basePrice.toFixed(2)}`;
        subOriginalDisplay.style.display = totalQty > 0 ? 'inline' : 'none';
    }
      if (totalQty > 0) {
          if (subDisplay) {
              subDisplay.style.display = 'inline';
              subDisplay.textContent = `$${discountedPrice.toFixed(2)}`;
          }

          if (subOriginalDisplay) {
              subOriginalDisplay.style.display = 'inline';
              subOriginalDisplay.textContent = `$${basePrice.toFixed(2)}`;
          }
      } else {
          if (subDisplay) subDisplay.style.display = 'none';
          if (subOriginalDisplay) subOriginalDisplay.style.display = 'none';
      }
    // difference between subscription discount and one-time discount
    const extraSavings = lastOneTimeDiscount - discountAmount;
    subpopupdiscount.textContent = `$${Math.abs(extraSavings).toFixed(2)}`;

    const addontotal = document.querySelector('.addon-total-price');
    if (addontotal) addontotal.textContent = addonTotal === 0 ? '' : `$${addonTotal.toFixed(2)}`;

    updateSubscriptionByQuantity(totalQty);
    updateTotalQty();
    updateBundleBorders();
    updateBundleProgress();
     window.toggleStickyBySelection?.(true);

}

        function updateTotalQty() {
            // Select all blocks
            const bundleBlocks = document.querySelectorAll('.Bundle-right-content');
            let totalQty = 0;

            bundleBlocks.forEach(block => {
                // Get quantity from data attribute
                let qty = parseInt(block.getAttribute('data-quantity')) || 0;
                totalQty += qty;
            });

            // Update the total count element
            const totalCountEl = document.querySelector('.bundle-total-count');
            if (totalCountEl) {
               totalCountEl.textContent = `(${totalQty})`; // 
            }
        }

// Auto subscription select box function code start from here
//  Reusable function you can call on qty change
function updateSubscriptionByQuantity(totalQty) {
 const globalSelect = document.getElementById('global-subscription-plan');
  if (globalSelect) {
    let targetInterval = null;
    if (totalQty === 1) targetInterval = '6 week';
    else if (totalQty === 2) targetInterval = '2 month';
    else if (totalQty === 3) targetInterval = '2 month';
    else if (totalQty === 4) targetInterval = '3 month';
    else if (totalQty === 0) targetInterval = '6 week';

    if (targetInterval) {
      const matchOption = Array.from(globalSelect.options).find(opt => {
        const optInterval = opt.textContent.toLowerCase();
        return optInterval.includes(targetInterval);
      });

      if (matchOption && globalSelect.value !== matchOption.value) {
        globalSelect.value = matchOption.value;
        globalSelect.dispatchEvent(new Event('change')); // Trigger syncing logic
      }
    }
  }
}

// code end here auto subscription selsction
//  Subscription selectbox code is starting from here

document.addEventListener("DOMContentLoaded", function () {
  const globalSelect = document.getElementById('global-subscription-plan');
  if (!globalSelect) return;

  let isAutoChanging = false;
  let userManuallySelected = false;

  function extractBaseInterval(text) {
    const match = text?.toLowerCase().match(/(\d+)\s*(week|weeks|month|months)/);
    return match ? `${match[1]} ${match[2].replace(/s$/, '')}` : null;
  }

  function updateHiddenSelects(baseInterval) {
    const hiddenSelects = document.querySelectorAll('.subscription-dropdown');
    hiddenSelects.forEach(select => {
      const matchOption = Array.from(select.options).find(opt => {
        const optInterval = extractBaseInterval(opt.getAttribute('data-interval') || opt.textContent);
        return optInterval === baseInterval;
      });

      if (matchOption) {
        select.value = matchOption.value;
        select.dispatchEvent(new Event('change'));
      } else {
        console.warn(`No match for "${baseInterval}" in hidden select for product ${select.dataset.productId}`);
      }
    });
  }

  // 🔍 Detect actual user interaction
  globalSelect.addEventListener('pointerdown', function () {
    userManuallySelected = true;
  });

  // Handle dropdown change
globalSelect.addEventListener('change', function (event) {
  event.stopPropagation();
  event.stopImmediatePropagation();
  const selectedOption = globalSelect.selectedOptions[0];
  const selectedText = selectedOption?.textContent || '';
  const baseInterval = extractBaseInterval(selectedText);

    if (!baseInterval) {
      console.error("Unable to extract base interval from:", selectedText);
      return;
    }

    //  Skip only true programmatic changes
    // if (isAutoChanging && !userManuallySelected) {
    //   isAutoChanging = false;
    //   return;
    // }

    // Manual or user-initiated
    updateHiddenSelects(baseInterval);

    //  Reset flags
    isAutoChanging = false;
    userManuallySelected = false;
  });

  // ✅ Optional: trigger once on load
  globalSelect.dispatchEvent(new Event('change'));

  // ✅ Expose for auto-triggering
  window.setGlobalSubscriptionAuto = function (targetInterval) {
    const matchOption = Array.from(globalSelect.options).find(opt =>
      opt.textContent.toLowerCase().includes(targetInterval)
    );

    if (matchOption && globalSelect.value !== matchOption.value) {
      isAutoChanging = true;
      globalSelect.value = matchOption.value;
      globalSelect.dispatchEvent(new Event('change'));
    }
  };
});

// subscription select box code end from here

// Remove Bundle code start from here
document.addEventListener('click', function (e) {
  const removeBtn = e.target.closest('.bundle-remove');
  if (!removeBtn) return;

  const bundleBlock = removeBtn.closest('.Bundle-right-content');
  if (!bundleBlock) return;

  // Variant IDs to remove from placeholders and match to left-side bundle
  const variantIdsRaw = bundleBlock.getAttribute('data-variant-ids') || '';
  const variantIdArray = variantIdsRaw.split(',').map(id => id.trim()).filter(Boolean);
  const variantCountMap = {};

  // Count variant ID occurrences for accurate decrement
  const bundleQty = parseInt(bundleBlock.getAttribute('data-quantity'), 10) || 1;

  // Count total units of each variant to remove
  variantIdArray.forEach(variantId => {
    variantCountMap[variantId] = (variantCountMap[variantId] || 0) + bundleQty;
  });

  // --- 1. Update RIGHT PLACEHOLDERS ---
  Object.entries(variantCountMap).forEach(([variantId, countToRemove]) => {
    const placeholder = document.querySelector(`.placeholder[data-variant-id="${variantId}"]`);
    if (!placeholder) return;

    const currentQty = parseInt(placeholder.getAttribute('data-quantity'), 10) || 0;
    const newQty = Math.max(0, currentQty - countToRemove);
    placeholder.setAttribute('data-quantity', newQty);

    const qtyEl = placeholder.querySelector('.product-qty');
    if (qtyEl) qtyEl.textContent = newQty;

    if (newQty === 0) {
      // Reset image
      const imgEl = placeholder.querySelector('.pro-right-image img');
      if (imgEl) {
        imgEl.src = 'https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Vector_85.png?v=1753096645';
      }

      // Remove placeholder-related attributes
      placeholder.removeAttribute('data-image');
      placeholder.removeAttribute('data-product-id');
      placeholder.removeAttribute('data-variant-id');
      placeholder.removeAttribute('data-has-subscription');
      placeholder.removeAttribute('data-quantity');
      updatePlaceholderActiveState();
    }
  });

  // --- 2. Update LEFT SIDE BUNDLE BLOCK ---
  document.querySelectorAll('.product-blockss').forEach(leftBundleBlock => {
    const blockVariantIds = [];

    // Collect all variant IDs from visible product-imageX blocks
    leftBundleBlock.querySelectorAll('[class^="product-image"]').forEach(el => {
      const variantId = el.getAttribute('data-variant-id');
      if (variantId) blockVariantIds.push(String(variantId).trim());
    });

    // Match only if all bundleBlock variant IDs are present (order doesn't matter)
    const isMatch =
      variantIdArray.length === blockVariantIds.length &&
      variantIdArray.every(id => blockVariantIds.includes(id));

    if (isMatch) {
      const qtyInput = leftBundleBlock.querySelector('.quantity__input');
      if (qtyInput) qtyInput.value = '0';

      const bundleQtty = leftBundleBlock.querySelector('.bundle-qtty');
      if (bundleQtty) bundleQtty.style.display = 'none';

      const bundleAtc = leftBundleBlock.querySelector('.bundle-atc');
      if (bundleAtc) bundleAtc.style.display = '';

      leftBundleBlock.classList.remove('active');
    }
  });

  // --- 3. Final Cleanup ---
  bundleBlock.setAttribute('data-quantity', '0');
  bundleBlock.remove();

  // --- 4. Hide bundle-selection-slots if no Bundle-right-content has data-variant-ids ---
  const hasValidBundle = Array.from(document.querySelectorAll('.Bundle-right-content'))
    .some(el => el.getAttribute('data-variant-ids'));

  if (!hasValidBundle) {
    document.querySelectorAll('.bundle-selection-slots').forEach(el => {
      el.style.display = 'none';
    });
  }

  // updateOneTimePriceDisplay();
  // updateSubscriptionPriceDisplay();
  updateAtcPriceBySelection();
  updateTabDots();
}); 

////////addons selection code add here/////

document.addEventListener("DOMContentLoaded", function () {
  const placeholders = Array.from(document.querySelectorAll('#selected-addons .placeholder'));

  // Utility: Get current selected price mode
  function getSelectedPurchaseType() {
    return document.querySelector('input[name="purchase-option"]:checked')?.value;
  }

  // Utility: Run correct price display function
  function updateCorrectPriceDisplay() {
    const selectedType = getSelectedPurchaseType();
    if (selectedType === 'subscription') {
      updateSubscriptionPriceDisplay();
    } else {
      updateOneTimePriceDisplay();
    }
  }

  // Bind addon buttons
  document.querySelectorAll('.addon-atc').forEach(button => {
    button.addEventListener('click', () => {
       
//  Activate the addon accordion section
    const accordionItem = document.querySelector('.accordion-item-addons');
    if (accordionItem) {
    const question = accordionItem.querySelector('.accordion-question');
    const answer = accordionItem.querySelector('.accordion-answer');

    if (question && answer) {
      question.classList.add('active');
      answer.classList.add('active');
    }
    }
     ///////////////////////////////
      const container = button.closest('.product-blockss');
      if (!container) return;

      const variantId = button.getAttribute('data-variant-id');
      const dataPrice = button.getAttribute('data-price');
      const images = [];
      const imgEl = container.querySelector(`.product-image1 img`);
      if (imgEl?.src && !imgEl.src.includes('no-image')) {
        images.push(imgEl.src);
      }

      images.forEach(src => {
        let slot = placeholders.find(ph => ph.dataset.image === src);
        if (!slot) slot = placeholders.find(ph => !ph.dataset.image);
        if (!slot) return;

        const idx = slot.dataset.index;
        slot.dataset.image = src;
        slot.dataset.variantId = variantId;
        slot.dataset.price = dataPrice;

        let variantInput = slot.querySelector(`input[name="variant-id-${idx}"]`);
        if (!variantInput) {
          variantInput = document.createElement('input');
          variantInput.type = 'hidden';
          variantInput.name = `variant-id-${idx}`;
          slot.appendChild(variantInput);
        }
        variantInput.value = variantId;

        let subInput = slot.querySelector(`input[name="subscription-${idx}"]`);
        if (!subInput) {
          subInput = document.createElement('input');
          subInput.type = 'hidden';
          subInput.name = `subscription-${idx}`;
          slot.appendChild(subInput);
        }

        slot.querySelector(`.product-image${idx}`).innerHTML =
          `<img src="${src}" alt="Selected">`;

        const qtyEl = slot.querySelector(`.product-qty${idx}`);
        const existingVal = parseInt(qtyEl.textContent, 10) || 0;
        qtyEl.textContent = existingVal + 1;

        const rm = slot.querySelector('.remove-btn');
        if (rm) rm.classList.remove('hidden');
      });

      const qtyInput = container.querySelector('.quantity__input');
      const minusBtn = container.querySelector('.qty-btn.minus');
      const plusBtn = container.querySelector('.qty-btn.plus');

      qtyInput.value = 1;
      updateAtcPriceBySelection();
      updateTabDots();
      button.classList.add('hidden');
      container.querySelector('.bundle-qtty').style.display = 'flex';
      container.classList.add('active');

      plusBtn.onclick = () => {
        let newVal = parseInt(qtyInput.value, 10) + 1;
        qtyInput.value = newVal;

        images.forEach(src => { 
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const existingVal = parseInt(qtyEl.textContent, 10) || 0;
            qtyEl.textContent = existingVal + 1;

            // --- ALWAYS SHOW CROSS WHEN QTY INCREASES ---
          const crossBtn = slot.querySelector('.remove-btn');
          if (crossBtn) crossBtn.classList.remove('hidden');
          }
        });
         updatePlaceholderActiveState();
        updateAtcPriceBySelection();
          updateTabDots();
      };

      minusBtn.onclick = () => {
        let newVal = parseInt(qtyInput.value, 10) - 1;
        if (newVal < 0) newVal = 0;
        qtyInput.value = newVal;

        images.forEach(src => {
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const idx = slot.dataset.index;
            const qtyEl = slot.querySelector(`.product-qty${idx}`);
            const existingVal = parseInt(qtyEl.textContent, 10) || 0;
            qtyEl.textContent = Math.max(0, existingVal - 1);

              const crossBtn = slot.querySelector('.remove-btn'); 

            if (parseInt(qtyEl.textContent, 10) === 0) {
              delete slot.dataset.image;
              delete slot.dataset.variantId;
              delete slot.dataset.subscription;

              slot.querySelector(`.product-image${idx}`).innerHTML =
                `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538228666.png?v=1753181342" alt="placeholder">`;
              qtyEl.textContent = '0';

              const variantInput = slot.querySelector(`input[name="variant-id-${idx}"]`);
              if (variantInput) variantInput.remove();

              const subInput = slot.querySelector(`input[name="subscription-${idx}"]`);
              if (subInput) subInput.remove();

        
            // --- HIDE CROSS WHEN QTY = 0 ---
            if (crossBtn) crossBtn.classList.add('hidden');
            }
            else {
            // --- SHOW CROSS IF QTY > 0 ---
            if (crossBtn) crossBtn.classList.remove('hidden');
          }
          }
        });

        if (newVal === 0) {
          button.classList.remove('hidden');
          container.querySelector('.bundle-qtty').style.display = 'none';
          container.classList.remove('active');

           // Also hide cross button explicitly when qty = 0
        images.forEach(src => {
          const slot = placeholders.find(ph => ph.dataset.image === src);
          if (slot) {
            const crossBtn = slot.querySelector('.remove-btn');
            if (crossBtn) crossBtn.classList.add('hidden');
          }
        });

                  //  If no more selected add-ons, remove active classes from accordion
       updateAddonAccordionState();
        }

        updateAtcPriceBySelection();
         updateTabDots();
      };

      // addons
      

      //////////////////
    });
  });
// addons remove code start from here
document.getElementById('selected-addons').addEventListener('click', function (e) {
  const btn = e.target.closest('.remove-btn');
  if (!btn) return;

  const slot = btn.closest('.placeholder');
  const idx = slot.dataset.index;
  const imageSrc = slot.dataset.image;

  // Reset the placeholder slot
  slot.querySelector(`.product-image${idx}`).innerHTML =
    `<img src="https://cdn.shopify.com/s/files/1/0609/4081/2536/files/Group_1538228666.png?v=1753181342" alt="placeholder">`;
  slot.querySelector(`.product-qty${idx}`).textContent = '0';

  delete slot.dataset.image;
  delete slot.dataset.variantId;
  delete slot.dataset.subscription;

  // Remove hidden inputs
  const variantInput = slot.querySelector(`input[name="variant-id-${idx}"]`);
  if (variantInput) variantInput.remove();

  const subInput = slot.querySelector(`input[name="subscription-${idx}"]`);
  if (subInput) subInput.remove();

  btn.classList.add('hidden');

  //  Now reset the corresponding left-side block (match by imageSrc)
  const blocks = document.querySelectorAll('.product-blockss');
  blocks.forEach(block => {
    const imgEl = block.querySelector('.product-image1 img');
    if (imgEl && imgEl.src === imageSrc) {
      const qtyInput = block.querySelector('.quantity__input');
      const qtyBox = block.querySelector('.bundle-qtty');
      const addBtn = block.querySelector('.addon-atc');

      if (qtyInput) qtyInput.value = 0;
      if (qtyBox) qtyBox.style.display = 'none';
      if (addBtn) addBtn.classList.remove('hidden');
       block.classList.remove('active');
    }
  });

  updateAtcPriceBySelection();
 updateAddonAccordionState();
});

// addons remive code end from here

            function updateAddonAccordionState() {
            //  If no more selected add-ons, remove active classes from accordion
                  const accordionItem = document.querySelector('.accordion-item-addons');
                  const hasAnySelected = [...document.querySelectorAll('#selected-addons .placeholder')]
                  .some(ph => ph.dataset.image); // checks if any placeholder has an image

                  if (!hasAnySelected && accordionItem) {
                  accordionItem.querySelector('.accordion-question')?.classList.remove('active');
                  accordionItem.querySelector('.accordion-answer')?.classList.remove('active');
                  }

            }
            
  // === Handle radio clicks ===
  function bindPurchaseOptionClick() {
    document.querySelectorAll('.purchase-options').forEach(label => {
      label.addEventListener('click', () => {
        const radio = label.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          updateCorrectPriceDisplay();
          
        }
      });
    });
  }

  // === Init ===
  const selected = getSelectedPurchaseType();
  updateCorrectPriceDisplay();
  bindPurchaseOptionClick();
});

/////////////////////////////

function updateOptionPriceOnClick(type) {
  if (type === 'subscription') {
    updateSubscriptionPriceDisplay();
  } else {
    updateOneTimePriceDisplay();
  }
}

document.addEventListener("DOMContentLoaded", function () {
const mainselector = document.querySelector('#global-subscription-plan')
if(mainselector){
mainselector.addEventListener('click', function(e){
e.stopPropagation();
})
}
});

    

    function updateAtcPriceBySelection() {
      const selected = document.querySelector('input[name="purchase-option"]:checked')?.value;
      const atcPriceDiv = document.querySelector('.add-total-price');

      if (!atcPriceDiv) return;

      if (selected === 'subscription') {
        const subPrice = document.querySelector('.subscription-discount-price')?.textContent?.trim();
        if (subPrice) atcPriceDiv.textContent = subPrice;
          updateSubscriptionPriceDisplay();
      } else {
        const oneTimePrice = document.querySelector('.one-time-discount-price')?.textContent?.trim();
        if (oneTimePrice) atcPriceDiv.textContent = oneTimePrice;
        updateOneTimePriceDisplay();

      }
    }

//  On initial load
window.addEventListener('DOMContentLoaded', () => {
  const selected = document.querySelector('input[name="purchase-option"]:checked')?.value;
const atcTotalText = document.querySelector('.addtocarttotal-text');
  if (atcTotalText) {
    atcTotalText.style.display = 'none';
  }
  // Set static initial price
  const atcPriceDiv = document.querySelector('.add-total-price');
  if (atcPriceDiv) {
    if (selected === 'subscription') {
      const subPrice = document.querySelector('.subscription-discount-price')?.textContent?.trim();
      if (subPrice) {
        atcPriceDiv.textContent = subPrice;
      }
    } else {
      const oneTimePrice = document.querySelector('.one-time-discount-price')?.textContent?.trim();
      if (oneTimePrice) {
        atcPriceDiv.textContent = oneTimePrice;
      }
    }
  }
 
    const elementsToHide = [
    '.subscription-original-price',
    '.subscription-discount-price',
    '.one-time-original-price',
    '.one-time-discount-price',
    '.addtocarttotal-text'
  ];

  elementsToHide.forEach(selector => {
    const el = document.querySelector(selector);
    if (el) el.style.display = 'none';
  });
  
  // bindPurchaseOptionClick();
  updateAtcPriceBySelection();
});

document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('.product-detail-drawer');
  const overlay = document.querySelector('.product-detail-drawer-overlay');
  const imagesSwiper = document.querySelector(
    '.product-detail-drawer-images-swiper .swiper-wrapper'
  );
  const drawerTitle = drawer.querySelector('.drawer-title');
  const reviews = drawer.querySelector('.reviews');
  const okendoContainer = drawer.querySelector('.oke-star-rating');
  const price = drawer.querySelector('.price');
  const drawerDes = drawer.querySelector('.drawer-description');
  const inspired = drawer.querySelector('.product-detail-drawer-content .inspired');
  const flavorsList = drawer.querySelector('.flavors-list');
  const scentsdesc = drawer.querySelector('.scents-description');
  const ingredienttitle = drawer.querySelector('.ingredient-title');
  const ingredientdesc = drawer.querySelector('.ingredient-description');
  const directiontitle = drawer.querySelector('.direction-title');
  const directiondesc = drawer.querySelector('.direction-description');
  const draweraddBtn = drawer.querySelector('.drawer-add-btn');
  const scentScaleWrapper = drawer.querySelector('.scent-scale-wrapper');
  const drawerReviewsWrapper = drawer.querySelector('.drawer-reviews-wrapper');
  const reviewsSwiperWrapper = drawer.querySelector('.drawer-reviews-wrapper .swiper-wrapper');
     function renderDrawerFeatureIcons(triggerEl) {
                const wrapper = document.querySelector('.drawer-feature-icons');
                const container = wrapper.querySelector('.feature-icons-outer');

                container.innerHTML = '';
                wrapper.classList.add('hidden');

                const rawData = triggerEl.dataset.featureIcons;
                if (!rawData) return;

                let icons;
                try {
                  icons = JSON.parse(rawData.replace(/&quot;/g, '"'));
                } catch (e) {
                  console.error('[Drawer Feature Icons] JSON parse failed', e);
                  return;
                }

                if (!icons.length) return;

                icons.forEach(icon => {
                  const iconHTML = `
                    <div class="feature-icons-with-title font-degular">
                      <div class="featured-icon">
                        <img src="${icon.image}" alt="${icon.title}">
                      </div>
                      <h3 class="font-degular">${icon.title}</h3>
                    </div>
                  `;
                  container.insertAdjacentHTML('beforeend', iconHTML);
                });

                wrapper.classList.remove('hidden');

             }
function renderScentScale(scale, handle) {
  if (!scale || !handle) return '';

  const baseHandle = handle
    .toLowerCase()
    .split('-')[0]
    .trim();

  return `
    <div class="scent-scale-wrapper scale-${baseHandle} scale-${scale}">
      <div class="scent-scale-title font-degular">Scent Scale</div>

      <div class="scent-scale-bar">
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
        <span class="scale-segment"></span>
      </div>

      <div class="scent-scale-labels">
        <span class="font-degular">LIGHT</span>
        <span class="font-degular">MEDIUM</span>
        <span class="font-degular">STRONG</span>
      </div>
    </div>
  `;
}

        

    function detailsToggleDrawer(open = true) {
    drawer.classList.toggle('open', open);
    overlay.classList.toggle('visible', open);
    document.body.classList.toggle('body-drawer-open', open);
  }
  const drawerBtns = document.querySelectorAll('.open-drawer-btn');
  const productDetailDrawerSwiper = new Swiper('.product-detail-drawer-images-swiper', {
    centeredSlides: true,
    centeredSlidesBounds: true,
    slidesPerView: 'auto',
    spaceBetween: 16,
    loop: true,
    pagination: {
      el: '.product-detail-drawer-images-swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  drawerBtns.forEach((drawerBtn) => {
    drawerBtn.addEventListener('click', function () {
      // Open drawer
      detailsToggleDrawer(true);
      const accordionItemScents = document.querySelector('.accordion-item-scents');
      const accordionItemIngredient = document.querySelector('.accordion-item-ingredient');
      const accordionItemDirection = document.querySelector('.accordion-item-direction');
      const productType = this.dataset.productType;
      const productId = this.dataset.productId;
      const productImages = this.dataset.images;
      const productTitle = this.dataset.productTitle;
      const productPrice = this.dataset.productPrice;
      const productDescription = this.dataset.description;
      const productScentsIncludedTitle = this.dataset.scentsincludedtitle;
      const productInspired = this.dataset.inspired;
      const productFlavors = this.dataset.flavors;
      const bundleScentsIncludedDesc = this.dataset.scentsincluded;
      const productIngredientTitle = this.dataset.ingredienttitle;
      const productIngredientDesc = this.dataset.ingrediendescription;
      const productDirectionTitle = this.dataset.directiontitle;
      const productDirectionDesc = this.dataset.descriptiondesc;
      const productReviewsRaw = this.dataset.productReviews;

      flavorsList.innerHTML = '';
      scentsdesc.innerHTML = '';
      flavorsList.classList.remove('hidden');
      accordionItemScents.classList.remove('hidden');
      accordionItemIngredient.classList.remove('hidden');
      accordionItemDirection.classList.remove('hidden');
      inspired.classList.remove('hidden');
      reviews.classList.remove('hidden');
      // Images
      if (imagesSwiper) {
        if (productImages != '') {
          const productImagesData = JSON.parse(productImages);
          productImagesData.forEach((image) => {
            if (!image) return;
            productDetailDrawerSwiper.appendSlide(`
              <div class="swiper-slide">
                <div class="product-detail-drawer-image">
                  <img src="${image}" alt="Product image" />
                </div>
              </div>
            `);
            //productDetailDrawerSwiper.update();
          });
        }
      }
      // title
      if (drawerTitle && productTitle) {
        drawerTitle.textContent = productTitle;
       }

            
        // Update the drawer button's data-title attribute
        if (draweraddBtn && productTitle) {
          // alert(draweraddBtn);
          draweraddBtn.setAttribute('data-title', productTitle);
        }

         if (draweraddBtn && productType) {
          // alert(draweraddBtn);
          draweraddBtn.setAttribute('data-product-type', productType);
        }
      // Price
      // if (price) {
      //   price.textContent = productPrice ? `$${parseFloat(productPrice).toFixed(2)}` : '';
      // }
      // flavor list - scents single sku
      if (flavorsList) {
        if (productFlavors.trim() != '') {
          const flavoursData = JSON.parse(productFlavors);
          flavoursData.forEach((f) => {
            const li = document.createElement('li');
            li.innerHTML = `
              <span class="tag-icon"><img src="${f.flavour_icon}" alt="${f.flavour_title}"></span>
              ${f.flavour_title}
            `;
            flavorsList.appendChild(li);
          });
        } else {
          flavorsList.classList.add('hidden');
        }
      }
      // reviews
      // reviews
      if (okendoContainer) {
      // const okendoSnippet = this.dataset.okendoSnippet;
      const productId = this.dataset.productId;
      const okendoEl = drawer.querySelector('.okendo-reviews');

      // set Product
      window.okeWidgetApi.setProduct(okendoContainer, productId);
      
      // Inject RAW snippet HTML
      // if (okendoSnippet) {
      //   okendoContainer.innerHTML = okendoSnippet;
      // } else {
      //   console.warn('[Okendo] Missing snippet');
      //   return;
      // }

  }

      

      // inspired
      if (inspired) {
        if (productInspired) {
          inspired.innerHTML = 'Inspired by: ' + productInspired;
        } else {
          inspired.classList.add('hidden');
        }
      }
                const scentHandle = this.dataset.scentHandle;
            const scentScale  = this.dataset.scentScale;

    //  FIXED RESET (nothing else touched)
      scentScaleWrapper.classList.remove(
        'hidden',
        ...Array.from(scentScaleWrapper.classList).filter(c => c.startsWith('scale-'))
      );

      if (scentHandle && scentScale) {
        scentScaleWrapper.classList.add(`scale-${scentHandle}`, `scale-${scentScale}`);
      } else {
        scentScaleWrapper.classList.add('hidden');
      }

      if (drawerReviewsWrapper && reviewsSwiperWrapper) {
        reviewsSwiperWrapper.innerHTML = '';
        drawerReviewsWrapper.classList.add('hidden');

        if (productReviewsRaw && productReviewsRaw !== 'null') {
          try {
            const reviewsData = JSON.parse(productReviewsRaw);

            if (Array.isArray(reviewsData) && reviewsData.length) {
              reviewsData.forEach((review) => {
                const slide = document.createElement('div');
                slide.className = 'product-single-review swiper-slide';
                slide.innerHTML = `
                  <div class="product-single-review-content">
                    ${review.review_description || ''}
                  </div>
                  ${
                    review.review_title
                      ? `<p class="product-single-review-author">${review.review_title}</p>`
                      : ''
                  }
                `;
                reviewsSwiperWrapper.appendChild(slide);
              });

              drawerReviewsWrapper.classList.remove('hidden');

              // Init / Re-init swiper
              if (window.drawerReviewsSwiper) {
                window.drawerReviewsSwiper.destroy(true, true);
              }

              window.drawerReviewsSwiper = new Swiper(
                '.drawer-reviews-wrapper .review-slider-wrapper',
                {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  loop: true,
                  speed: 800,
                  autoHeight: true,
                  autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                  },
                  navigation: {
                    nextEl:
                      '.drawer-reviews-wrapper .swiper-button-next',
                    prevEl:
                      '.drawer-reviews-wrapper .swiper-button-prev',
                  },
                  breakpoints: {
                    990: {
                      spaceBetween: 30,
                      autoHeight: false,
                    },
                  },
                }
              );
            }
          } catch (e) {
            console.warn('[Drawer Reviews] Invalid review data', e);
          }
        }
      }

      renderDrawerFeatureIcons(drawerBtn);
      // description
      if (drawerDes) {
        drawerDes.innerHTML = productDescription || '';
      }
      // scents accordion
// scents accordion
      if (scentsdesc) {
        if (bundleScentsIncludedDesc != '') {
          const bundleScentsData = JSON.parse(bundleScentsIncludedDesc);

          bundleScentsData.forEach((bundleProduct) => {
            if (!bundleProduct.productTitle) return;

            const wrapper = document.createElement('div');
            wrapper.className = 'accordion-scent-include';

            wrapper.innerHTML = `
              <div class="accordion-scent-include-title font-degular">
                ${bundleProduct.productTitle}
              </div>

              <p class="accordion-scent-include-inspired font-degular">
                Inspired by ${bundleProduct.productInspired || ''}
              </p>

              <ul class="tags font-degular">
                ${bundleProduct.productFlavours
                  .map(
                    (f) => `
                      <li>
                        <img class="tag-icon" src="${f.flavour_icon}" alt="${f.flavour_title}" />
                        ${f.flavour_title}
                      </li>
                    `
                  )
                  .join('')}
              </ul>

              ${renderScentScale(
                bundleProduct.productScentScale,
                bundleProduct.productScentHandle
          )}

            `;

            scentsdesc.appendChild(wrapper);
          });
        } else {
          accordionItemScents.classList.add('hidden');
        }
      }

      // ingredients accordion
      if (ingredientdesc) {
        if (productIngredientDesc != '') {
          ingredientdesc.innerHTML = productIngredientDesc;
        } else {
          accordionItemIngredient.classList.add('hidden');
        }
      }
      // directions accordion
      // if (directiondesc) {
      //   if (productDirectionDesc != '') {
      //     directiondesc.innerHTML = productDirectionDesc || '';
      //   } else {
      //     accordionItemDirection.classList.add('hidden');
      //   }
      // }
      // directions accordion
      if (accordionItemDirection && directiontitle && directiondesc) {
        const hasTitle = productDirectionTitle && productDirectionTitle.trim() !== '';
        const hasDesc  = productDirectionDesc && productDirectionDesc.trim() !== '';

        if (hasTitle && hasDesc) {
          directiontitle.textContent = productDirectionTitle;
          directiondesc.innerHTML = productDirectionDesc;
          accordionItemDirection.classList.remove('hidden');
        } else {
          accordionItemDirection.classList.add('hidden');
        }
      }

    });
  });
  const closeBtn = drawer.querySelector('.close-btn');
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      detailsToggleDrawer(false);
      productDetailDrawerSwiper.removeAllSlides();
    });
  }

  // Close when clicking outside the drawer
    document.addEventListener('click', (e) => {
      const isDrawerOpen = drawer.classList.contains('open');
      const clickedInsideDrawer = drawer.contains(e.target);
      const clickedOpenBtn = e.target.closest('.open-drawer-btn');

      // Only close if drawer is open and click is outside
      if (isDrawerOpen && !clickedInsideDrawer && !clickedOpenBtn) {
        detailsToggleDrawer(false);
        productDetailDrawerSwiper.removeAllSlides();
      }
    });

   // Drawer add Bundle builder code start from here
    document.addEventListener('click', function(e) {
      const drawerBtn = e.target.closest('.drawer-add-btn');
      if (!drawerBtn) return;

      detailsToggleDrawer(false);
      productDetailDrawerSwiper.removeAllSlides();

      const productTitle = (drawerBtn.getAttribute('data-title') || '').trim();
      const productType  = (drawerBtn.getAttribute('data-product-type') || '').trim(); // "bundle", "single", "addon"
      if (!productTitle) return;
      // --- ADDON PRODUCTS ---
      // if (productType === 'addon') {
      //   const addonBtn = Array.from(document.querySelectorAll('.addon-atc'))
      //     .find(btn => (btn.getAttribute('data-addon-product') || '').trim() === productTitle);

      //   if (!addonBtn) {
      //     console.warn('[Drawer] No .addon-atc button found for addon:', productTitle);
      //     return;
      //   }

      //   addonBtn.click(); // trigger existing addon logic
      //   return;
      // }

      // --- BUNDLES & SINGLE PRODUCTS ---
      const atcBtn = Array.from(document.querySelectorAll('.bundle-atc')).find(btn => {
        const titleAttr = (btn.getAttribute('data-title') || '').trim();
        const singleAttr = (btn.getAttribute('data-single-product') || '').trim();
        return titleAttr === productTitle || singleAttr === productTitle;
      });

      if (!atcBtn) {
        console.warn('[Drawer] No .bundle-atc button found for title:', productTitle);
        return;
      }

      const container = atcBtn.closest('.product-blockss');
      const isBundle = atcBtn.hasAttribute('data-title');
      const qtyBox = container?.querySelector('.quantity__input');

      if (qtyBox && container.querySelector('.bundle-qtty').style.display === 'flex') {
        // Already added → increment quantity
        let newQty = parseInt(qtyBox.value, 10) + 1;
        qtyBox.value = newQty;

        const placeholders = Array.from(document.querySelectorAll('#selected-scents .placeholder'));

        if (isBundle) {
          // --- Update bundle block ---
          const bundleTitle = (atcBtn.getAttribute('data-title-new') || atcBtn.getAttribute('data-title') || '').trim();
          const bundleBlock = Array.from(document.querySelectorAll('.Bundle-right-content'))
            .find(el => el.getAttribute('data-bundle-title') === bundleTitle);
          if (bundleBlock) {
            bundleBlock.querySelector('.selected-bundle-qty').textContent = newQty;
            bundleBlock.setAttribute('data-quantity', newQty);
          }

          // --- Update each product inside bundle ---
          const productEntries = [];
          for (let i = 1; i <= 4; i++) {
            const block = container.querySelector(`.product-image${i}`);
            const imgEl = block?.querySelector('img');
            if (!imgEl || imgEl.src.includes('no-image')) continue;
            productEntries.push({
              src: imgEl.src,
              variantId: block.getAttribute('data-variant-id') || ''
            });
          }

          productEntries.forEach(({ src, variantId }) => {
            const slot = placeholders.find(ph => ph.dataset.image === src);
            if (slot) {
              const idx = slot.dataset.index;
              slot.querySelector(`.product-qty${idx}`).textContent = newQty;
              slot.setAttribute('data-quantity', newQty);
            }
          });

        } else {
          // --- Single product ---
          const variantId = container.querySelector('.product-image1')?.getAttribute('data-variant-id');
          const block = Array.from(document.querySelectorAll('.Bundle-right-content'))
            .find(el => el.dataset.variantIds === variantId);
          if (block) {
            block.querySelector('.selected-bundle-qty').textContent = newQty;
            block.setAttribute('data-quantity', newQty);
          }

          const slot = placeholders.find(ph => ph.dataset.variantId === variantId);
          if (slot) {
            const idx = slot.dataset.index;
            slot.querySelector(`.product-qty${idx}`).textContent = newQty;
            slot.setAttribute('data-quantity', newQty);
          }
        }

        toggleEmptyBundleMessage();
        updateAtcPriceBySelection();
        // updateOneTimePriceDisplay();
        // updateSubscriptionPriceDisplay();
        updatePlaceholderActiveState();
      

      } else {
        // Not added yet → trigger original .bundle-atc click
        atcBtn.click();
      }
    });
  // Drawer add Bundle builder code end  here

});
// Bundle subscription sorting code start from here
document.addEventListener('DOMContentLoaded', function () {
  const select = document.getElementById('global-subscription-plan');
  const options = Array.from(select.options);

  // Define your desired order exactly as it appears in the text
  const order = [
    "Delivered every 4 weeks",
    "Delivered every 6 weeks",
    "Delivered every 2 months",
    "Delivered every 3 months",
    "Delivered every 4 months"
  ];

  options.sort((a, b) => {
    const indexA = order.indexOf(a.textContent.trim());
    const indexB = order.indexOf(b.textContent.trim());

    // If an option is not in the order array, put it at the end
    return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  });

  // Remove existing options and append the sorted ones
  select.innerHTML = '';
  options.forEach(opt => select.appendChild(opt));
});

// Buy once button atc code start here  for new subscription version

//  Separate Buy Once Script
document.addEventListener("DOMContentLoaded", function () {
  const buyOnceBtn = document.querySelector(".btn-onetime-buy");
  if (!buyOnceBtn) return;

  buyOnceBtn.addEventListener("click", async function (e) {
    e.preventDefault();
    buyOnceBtn.classList.add("disable", "loading");

    const blocks = Array.from(document.querySelectorAll(".Bundle-right-content"));
    const items = [];
    let hasValidProduct = false;
    const processedBundles = new Set();

    blocks.forEach((block, i) => {
      const uniqueId = `m${Math.random().toString(36).substr(2, 9)}`;
      const fullBundleTitle = block.dataset.bundleTitle?.trim();
      const bundleTitle = fullBundleTitle?.split("_")[0];
      const quantity = parseInt(block.dataset.quantity, 10) || 1;
      const variantIds = (block.dataset.variantIds || "")
        .split(",")
        .map(id => id.trim())
        .filter(Boolean);

      if (variantIds.length === 0 || quantity <= 0) return;
      hasValidProduct = true;

      //  Bundle
      if (fullBundleTitle) {
        if (processedBundles.has(fullBundleTitle)) return;
        processedBundles.add(fullBundleTitle);

        const titles = Array.from(
          block.querySelectorAll(".selected-bundle-products div")
        ).map(d => d.textContent.trim());

        variantIds.forEach((variantId, index) => {
          const item = {
            id: parseInt(variantId, 10),
            quantity: quantity,
            properties: {
              "_bundle_items": true,
              "_unique_id": uniqueId,
              "Bundle Name": bundleTitle,
              "Included Products": titles.join(", "),
              "Purchase Type": "One Time" // 🔹 Force one-time
            }
          };
          items.push(item);
        });
      }
      //  Single
      else {
        const item = {
          id: parseInt(variantIds[0], 10),
          quantity: quantity,
          properties: {
            "Purchase Type": "One Time" // 🔹 Force one-time
          }
        };
        items.push(item);
      }
    });

    //  Addons
    const addonSlots = Array.from(document.querySelectorAll("#selected-addons .placeholder"));
    addonSlots.forEach((slot, i) => {
      const variantId = slot.dataset.variantId;
      const qtyEl = slot.querySelector(`.product-qty${slot.dataset.index}`);
      const quantity = parseInt(qtyEl?.textContent || "0", 10);

      if (variantId && quantity > 0) {
        hasValidProduct = true;
        items.push({
          id: parseInt(variantId, 10),
          quantity: quantity,
          properties: { "_addon_item": true, "Purchase Type": "One Time" }
        });
      }
    });

    if (!hasValidProduct) {
      alert("Please select at least one scent or bundle.");
      buyOnceBtn.classList.remove("disable", "loading");
      return;
    }

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items })
      });

      if (!response.ok) {
        const errData = await response.json();
        throw new Error(errData.description || "Unknown cart error");
      }

      const data = await response.json();

      if (window.openSidecart) {
        window.openSidecart();
        if (window.fetchCart) window.fetchCart();
      }
    } catch (err) {
      console.error(" Buy Once failed:", err);
      alert(err);
    } finally {
      buyOnceBtn.classList.remove("disable", "loading");
    }
  });
});

// mobile addtocart sticky script
 
// document.addEventListener('DOMContentLoaded', () => {
//   const atc = document.querySelector('.btn-outer-bg');
//   if (!atc) return;

//   const stickPosition = atc.offsetTop; // button position from top
//   const offset = 150; // delay sticky by 150px
//   const scrollThreshold = 200; // start sticky after 200px scroll

//   window.addEventListener('scroll', () => {
//     const scroll = window.scrollY; // current scroll from top
//     const viewportHeight = window.innerHeight;

//     // Sticky appears after threshold and removed when button enters viewport
//     if (scroll > scrollThreshold && scroll + viewportHeight < stickPosition + offset) {
//       atc.classList.add('sticky');
//     } else {
//       atc.classList.remove('sticky');
//     }
//   });
// });

document.addEventListener('DOMContentLoaded', () => {
  const arrowUp = document.querySelector('.mob-arrow-icons');      // first icon
  const arrowDown = document.querySelector('.mob-arrow-icons-down'); // second icon
  const tabContents = document.querySelector('.subscription-container .tab-contents');

  // Ensure initial state (optional)
  arrowDown.style.display = 'none'; 
  // tabContents.style.display = 'none';

  // Click on arrow up → show content + swap icons
  arrowUp.addEventListener('click', () => {
    tabContents.style.display = 'block';
    arrowDown.style.display = 'block';
    arrowUp.style.display = 'none';
  });

  // Click on arrow down → hide content + swap icons
  arrowDown.addEventListener('click', () => {
    tabContents.style.display = 'none';
    arrowUp.style.display = 'block';
    arrowDown.style.display = 'none';
  });
});

function updateBundleBorders() {

  const blocks = document.querySelectorAll('.Bundle-right-content');
  const validBlocks = Array.from(blocks).filter(b => 
    b.dataset.bundleTitle || b.dataset.productId || b.dataset.variantId
  );

  if (validBlocks.length === 1) {
    validBlocks[0].querySelector('.bundle-title-qty-outer').style.borderBottom = 'none';
  } else if (validBlocks.length > 1) {
    validBlocks.forEach(b => {
      b.querySelector('.bundle-title-qty-outer').style.borderBottom = '1px dashed #D3D5D6';
    });
  }
}

function updateBundleProgress() {

  /* -------------------------
     SUBSCRIPTION CHECK (GLOBAL)
  -------------------------- */
  const subRadio = document.getElementById("radio-sub");
  const isSubscriptionMode = subRadio ? subRadio.checked : false;

  /* -------------------------
     SVG ICONS
  -------------------------- */
  const icons = {
    gift: `<svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none" aria-hidden="true">
<circle cx="23" cy="23" r="23" fill="#F6D4D2"/>
<path d="M19.6326 17C17.8428 16.9901 16.1004 18.8038 16.8958 21.0559H13.8939C13.3917 21.0559 12.9099 21.2659 12.5548 21.6396C12.1995 22.0134 12 22.5203 12 23.0489V25.042C12 25.3062 12.0997 25.5597 12.2773 25.7465C12.4549 25.9335 12.6958 26.0385 12.947 26.0385H21.4697V23.0489H23.3637V26.0385H31.8863C32.1375 26.0385 32.3784 25.9335 32.556 25.7465C32.7336 25.5597 32.8333 25.3062 32.8333 25.042V23.0489C32.8333 22.5203 32.6338 22.0134 32.2786 21.6396C31.9234 21.2659 31.4417 21.0559 30.9394 21.0559H27.9375C29.0454 17.7973 24.8788 15.4953 22.9564 18.3055L22.4167 19.0629L21.8769 18.2855C21.2803 17.3987 20.4564 17.01 19.6326 17ZM19.5758 19.0629C20.4186 19.0629 20.8447 20.1391 20.2481 20.7669C19.6515 21.3947 18.6288 20.9463 18.6288 20.0594C18.6288 19.795 18.7286 19.5416 18.9062 19.3547C19.0838 19.1679 19.3246 19.0629 19.5758 19.0629ZM25.2576 19.0629C26.1004 19.0629 26.5265 20.1391 25.9299 20.7669C25.3333 21.3947 24.3106 20.9463 24.3106 20.0594C24.3106 19.795 24.4104 19.5416 24.588 19.3547C24.7656 19.1679 25.0064 19.0629 25.2576 19.0629ZM12.947 27.035V35.007C12.947 35.5356 13.1465 36.0425 13.5017 36.4163C13.8568 36.79 14.3386 37 14.8409 37H29.9924C30.4948 37 30.9764 36.79 31.3317 36.4163C31.6868 36.0425 31.8863 35.5356 31.8863 35.007V27.035H23.3637V35.007H21.4697V27.035H12.947Z" fill="#151414"/>
<line x1="16.2367" y1="10.3212" x2="18.095" y2="13.1085" stroke="#AA5841" stroke-width="1.28572" stroke-linecap="round"/>
<line x1="29.4881" y1="10.1429" x2="27.6298" y2="12.9302" stroke="#AA5841" stroke-width="1.28572" stroke-linecap="round"/>
<line x1="22.6429" y1="6.64286" x2="22.6429" y2="12.3571" stroke="#AA5841" stroke-width="1.28572" stroke-linecap="round"/>
</svg>`,
    onetimeicon: `<svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" aria-hidden="true">
<path d="M16.4258 19.5928H32.0742C32.813 19.5928 33.5215 19.8868 34.0439 20.4092C34.5664 20.9316 34.8604 21.6401 34.8604 22.3789V31.5068C34.8604 32.2456 34.5663 32.9541 34.0439 33.4766C33.5215 33.999 32.813 34.2929 32.0742 34.293H16.4258C15.6869 34.293 14.9785 33.999 14.4561 33.4766C13.9337 32.9541 13.6396 32.2456 13.6396 31.5068V22.3789C13.6396 21.64 13.9336 20.9316 14.4561 20.4092C14.9785 19.8867 15.6869 19.5928 16.4258 19.5928ZM24.25 22.5566C23.6055 22.5566 22.987 22.8128 22.5312 23.2686C22.0756 23.7243 21.8193 24.3428 21.8193 24.9873V28.8994C21.8194 29.5437 22.0757 30.1615 22.5312 30.6172C22.987 31.0729 23.6055 31.3291 24.25 31.3291C24.8945 31.3291 25.513 31.0729 25.9688 30.6172C26.4242 30.1616 26.6796 29.5437 26.6797 28.8994V24.9873C26.6797 24.3429 26.4244 23.7243 25.9688 23.2686C25.513 22.8128 24.8945 22.5567 24.25 22.5566Z" fill="#9B9B9B" stroke="#9B9B9B" stroke-width="2.25241"/>
<path d="M19.0488 19.7649V15.8528C19.0488 14.4694 19.5984 13.1427 20.5766 12.1645C21.5548 11.1863 22.8815 10.6367 24.2649 10.6367C25.6483 10.6367 26.9751 11.1863 27.9533 12.1645C28.9315 13.1427 29.4811 14.4694 29.4811 15.8528V19.7649" stroke="#9B9B9B" stroke-width="4.50483" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.23633 38.5791C10.4524 43.8064 16.91 47.1503 24.1485 47.1503C30.8528 47.1503 36.887 44.2819 41.091 39.7053" stroke="#9B9B9B" stroke-width="2.3" stroke-linecap="round"/>
<path d="M24.1504 1.15039C11.4478 1.15039 1.15039 11.4478 1.15039 24.1504C1.15039 29.6144 3.05571 34.6334 6.23819 38.5792" stroke="#9B9B9B" stroke-width="2.3"/>
<path d="M41.0929 39.7054C44.8542 35.6107 47.1504 30.1487 47.1504 24.1504C47.1504 11.4478 36.8529 1.15039 24.1504 1.15039" stroke="#9B9B9B" stroke-width="2.3" stroke-linecap="round"/>
</svg>`
  };

  function copyFrom(el, key, fallback) {
    const value = el?.dataset?.[key];
    return value && value.trim() ? value : fallback;
  }

  function setProgressChecks(bundleProgress, checks) {
    const checkpoints = bundleProgress.querySelectorAll('.progress-checkpoint');
    const filledSegments = checks === 0 ? 0 : checks === 1 || checks === 2 ? 1 : checks === 3 ? 2 : 3;

    bundleProgress.dataset.checks = String(checks);
    bundleProgress.dataset.filledSegments = String(filledSegments);
    checkpoints.forEach((checkpoint, index) => {
      checkpoint.classList.toggle('is-complete', index < checks);
      checkpoint.classList.toggle('is-filled', index < filledSegments);
    });
  }

  function setFreeGiftsState(showTwoGifts) {
    document.querySelectorAll('.product-subscription-free-gifts').forEach((row) => {
      row.classList.toggle('has-two-gifts', showTwoGifts);
    });
  }

  /* -------------------------
     BUNDLE QUANTITY (GLOBAL)
  -------------------------- */
  const nonMistQty = getNonMistTotalQty();
  const mistQty = getMistTotalQty();
  const isMistOnly = mistQty > 0 && nonMistQty === 0;

  // Birthday Gift Drop (CNV-3174): announce builder state for the parallel
  // birthday bar. Additive only — everything below is untouched.
  document.dispatchEvent(new CustomEvent('mozi:bundle:progress', {
    detail: { nonMistQty, mistQty, isSubscriptionMode }
  }));

  /* -------------------------
     UPDATE EACH PROGRESS BAR
  -------------------------- */
  document.querySelectorAll('.bundle-progress').forEach(bundleProgress => {
    const titleEl = bundleProgress.querySelector('.progress-title');
    const subtitleEl = bundleProgress.querySelector('.progress-subtitle');
    const progressBar = bundleProgress.querySelector('.progress-bar');
    const iconContainer = bundleProgress.querySelector('.progress-icon');

    if (!titleEl || !subtitleEl || !progressBar || !iconContainer) return;

    /* -------------------------
        NON-SUBSCRIPTION STATE
    -------------------------- */
    if (!isSubscriptionMode) {
      bundleProgress.classList.add('is-onetime');
      titleEl.textContent = copyFrom(bundleProgress, 'onetimeTitle', 'Big Savings + FREE Rewards Await');
      subtitleEl.textContent = copyFrom(bundleProgress, 'onetimeSubtitle', 'SUBSCRIBE NOW to claim benefits');
      setProgressChecks(bundleProgress, 0);
      iconContainer.innerHTML = icons.onetimeicon;
      setFreeGiftsState(false);
      return;
    }

    /* -------------------------
        SUBSCRIPTION MODE
    -------------------------- */
    bundleProgress.classList.remove('is-onetime');
    iconContainer.innerHTML = icons.gift;

    if (nonMistQty === 0 && mistQty === 0) {
      titleEl.textContent = copyFrom(bundleProgress, 'step0Title', 'Start Building Your Bundle – Select an Item!');
      subtitleEl.textContent = copyFrom(bundleProgress, 'step0Subtitle', 'Add first item to unlock FREE SHIPPING!');
      setProgressChecks(bundleProgress, 0);
      setFreeGiftsState(false);
    } else if (isMistOnly) {
      titleEl.textContent = copyFrom(bundleProgress, 'mistTitle', "You've Unlocked FREE SHIPPING!");
      subtitleEl.textContent = copyFrom(bundleProgress, 'mistSubtitle', 'Subscription includes FREE SHIPPING only.');
      setProgressChecks(bundleProgress, 1);
      setFreeGiftsState(false);
    } else if (nonMistQty === 1) {
      titleEl.textContent = copyFrom(bundleProgress, 'step1Title', 'Free shipping + cup unlocked');
      subtitleEl.textContent = copyFrom(bundleProgress, 'step1Subtitle', 'Add 1 more for a $15+ Mystery Gift.');
      setProgressChecks(bundleProgress, 1);
      setFreeGiftsState(false);
    } else if (nonMistQty === 2) {
      titleEl.textContent = copyFrom(bundleProgress, 'step2Title', '$25+ in gifts unlocked');
      subtitleEl.textContent = copyFrom(bundleProgress, 'step2Subtitle', 'You got free shipping, cup + Mystery Gift.');
      setProgressChecks(bundleProgress, 2);
      setFreeGiftsState(true);
    } else if (nonMistQty === 3) {
      titleEl.textContent = copyFrom(bundleProgress, 'step3Title', '1 more for best savings');
      subtitleEl.textContent = copyFrom(bundleProgress, 'step3Subtitle', 'Add 1 more to unlock the best bundle price.');
      setProgressChecks(bundleProgress, 3);
      setFreeGiftsState(true);
    } else {
      titleEl.textContent = copyFrom(bundleProgress, 'step4Title', 'Best savings unlocked');
      subtitleEl.textContent = copyFrom(bundleProgress, 'step4Subtitle', 'You have $25+ in gifts + free shipping. Keep adding to save more.');
      setProgressChecks(bundleProgress, 4);
      setFreeGiftsState(true);
    }
  });
}

// mozi lab add to cart code start here

document.addEventListener('click', function (e) {
  const button = e.target.closest('.lab-atc');
  if (!button) return;

  e.preventDefault();

  // prevent double click
  if (button.classList.contains('loading')) return;

  button.classList.add('disable', 'loading');

  const variantId = button.dataset.variantId;
  if (!variantId) {
    console.error('No variant ID found');
    button.classList.remove('disable', 'loading');
    return;
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => res.json())
  .then(data => {

    // ---- OPEN CART DRAWER ----
    if (window.openSidecart) {
      window.openSidecart();
      if (window.fetchCart) window.fetchCart();
    }
  })
  .catch(err => {
    console.error('Add to cart error:', err);
  })
  .finally(() => {
    button.classList.remove('disable', 'loading');
  });
});

function getNonMistTotalQty() {
  let total = 0;

  document
    .querySelectorAll('#selected-scents .placeholder')
    .forEach(slot => {
      const qty = parseInt(slot.dataset.quantity || '0', 10);
      const isMist = slot.dataset.isMist === 'true';

      // ❌ skip mist items
      if (isMist) return;

      total += qty;
    });

  return total;
}

function getMistTotalQty() {
  let total = 0;

  document
    .querySelectorAll('#selected-scents .placeholder')
    .forEach(slot => {
      const qty = parseInt(slot.dataset.quantity || '0', 10);
      const isMist = slot.dataset.isMist === 'true';

      if (isMist) {
        total += qty;
      }
    });

  return total;
}

     window.toggleStickyBySelection = function () {
      const stickyCart = document.querySelector('.subscription-container.variant-four');
      if (!stickyCart) return;

      // Desktop untouched
      // if (window.innerWidth > 768) return;

      if (hasAnySelection()) {
        stickyCart.classList.add('stickycart-bar-show-mob');
        document.body.classList.add('stickycart-bar-show');
      } else {
        stickyCart.classList.remove('stickycart-bar-show-mob');
        document.body.classList.remove('stickycart-bar-show');
      }
    };
function hasAnySelection() {
  return Array.from(
    document.querySelectorAll('.selection-slots .placeholder')
  ).some(slot => parseInt(slot.dataset.quantity || '0', 10) > 0);
}
 

